import { createReducer, on } from '@ngrx/store';
import { BannersActions } from '../_actions/banners.actions';
import { BannerModel } from '../../_models/banner.model';

export interface BannersState {
  list: {
    filters: any;
    data: ReadonlyArray<BannerModel>;
    total: number;
    activeCount: number;
  };
  selected: BannerModel | null;
}

export const initialStateBanner: BannersState = {
  list: {
    filters: {},
    data: [],
    total: 0,
    activeCount: 0,
  },
  selected: null,
};

export const bannersFeatureKey = 'banners';

export const bannersReducer = createReducer(
  initialStateBanner,
  on(BannersActions.loadBanners, (state, { filters }) => ({
    ...state,
    list: {
      ...state.list,
      filters,
    },
  })),
  on(BannersActions.loadBannersSuccess, (state, { items, total, activeCount }) => ({
    ...state,
    list: {
      ...state.list,
      data: items,
      total: total,
      activeCount: activeCount,
    },
  })),
  on(BannersActions.loadBannerSuccess, (state, { data }) => ({
    ...state,
    selected: data,
  })),
  on(BannersActions.addBannerSuccess, (state, { data }) => ({
    ...state,
    list: {
      ...state.list,
      data: [...state.list.data, data],
      total: state.list.total + 1,
    },
  })),
  on(BannersActions.editBannerSuccess, (state, { id, data }) => ({
    ...state,
    list: {
      ...state.list,
      data: state.list.data.map(banner => banner.id === id ? data : banner),
    },
    selected: state.selected?.id === id ? data : state.selected,
  })),
  on(BannersActions.toggleBannerSuccess, (state, { data }) => ({
    ...state,
    list: {
      ...state.list,
      data: state.list.data.map(banner => banner.id === data.id ? data : banner),
    },
    selected: state.selected?.id === data.id ? data : state.selected,
  })),
  on(BannersActions.removeBannerSuccess, (state, { id }) => ({
    ...state,
    list: {
      ...state.list,
      data: state.list.data.filter(banner => banner.id !== id),
      total: state.list.total - 1,
    },
    selected: state.selected?.id === id ? null : state.selected,
  }))
);
